import type { newFieldType } from "server/schemas/table-fields";

export const STRINGS = {
  Chatbot: "Chatbot",
  Config: "Config",
  Content: "Content",
  Data: "Data",
  Actions: "Actions",
  Embed: "Embed",
  "Generated from prompt:": "Generated from prompt:",
  "Chatbot name": "Chatbot name",
  "Build an AI-powered chatbot.": "Build an AI-powered chatbot.",
  "Say hello and tell me what you can do.":
    "Say hello and tell me what you can do.",
  "How can I help you today?": "How can I help you today?",
  "Ask me anything": "Ask me anything",
  "You are an AI chatbot. You are a helpful assistant.":
    "You are an AI chatbot. You are a helpful assistant.",
  "Sorry, I don’t know.": "Sorry, I don’t know.",
  "URL must be at least 4 characters": "URL must be at least 4 characters",
  "This field is required": "This field is required",
  "This field must be no more than {{count}} characters":
    "This field must be no more than {{count}} characters",
  "Action triggered!": "Action triggered!",
  "User gets a response": "User gets a response",
  "Display a button": "Display a button",
  "Copy response": "Copy response",
  "Run Zap": "Run Zap",
  "No response was generated.": "No response was generated.",
  "Unknown error occurred": "Unknown error occurred",
  "You've reached the chat completion limit for this session.":
    "You've reached the chat completion limit for this session.",
  "Something went wrong.": "Something went wrong.",
  "Hmm, things are taking a bit too long. You can try again, or try a different question.":
    "Hmm, things are taking a bit too long. You can try again, or try a different question.",
  "Chatbot is responding...": "Chatbot is responding...",
  Send: "Send",
  Close: "Close",
  Loading: "Loading",
  "This response is helpful": "This response is helpful",
  "This response is not helpful": "This response is not helpful",
  "Rating feedback": "Rating feedback",
  "Submit feedback": "Submit feedback",
  "What do you like about the response?":
    "What do you like about the response?",
  "What do you dislike about the response?":
    "What do you dislike about the response?",
  "This is an automated chatbot response. [Learn more](https://zapier.com/legal/terms-of-service)":
    "This is an automated chatbot response. [Learn more](https://zapier.com/legal/terms-of-service)",
  "Prompt input provided to the response above":
    "Prompt input provided to the response above",
  "Response generated to the prompt input above":
    "Response generated to the prompt input above",
  "This is a demo response": "This is a demo response",
  "Greeting generated from prompt": "Greeting generated from prompt",
  "Thanks for the feedback!": "Thanks for the feedback!",
  "Jump to latest": "Jump to latest",
  Height: "Height",
  "Prompt placeholder": "Prompt placeholder",
  Greeting: "Greeting",
  "This will be the first message the user sees.":
    "This will be the first message the user sees.",
  "The chatbot will generate the first message the user sees based on its directive and this prompt.":
    "The chatbot will generate the first message the user sees based on its directive and this prompt.",
  Directive: "Directive",
  "Tell the bot how you’d like it to respond. You can include style, tone, accent, and more.":
    "Tell the bot how you’d like it to respond. You can include style, tone, accent, and more.",
  "Disclosure message": "Disclosure message",
  "Required for Zapier employees.": "Required for Zapier employees.",
  "Data sources": "Data sources",
  "This input accepts markdown links.": "This input accepts markdown links.",
  "OpenAI authentication": "OpenAI authentication",
  "This authentication isn’t working.": "This authentication isn’t working.",
  "List of connected OpenAI authentications":
    "List of connected OpenAI authentications",
  Model: "Model",
  "List of available GPT models": "List of available GPT models",
  "Model availability depends on the selected authentication.":
    "Model availability depends on the selected authentication.",
  "When results are not found from the data source":
    "When results are not found from the data source",
  "Generate an AI response without data sources":
    "Generate an AI response without data sources",
  "Show a custom message": "Show a custom message",
  Sources: "Sources",
  "No data sources": "No data sources",
  "Custom message": "Custom message",
  "List of behaviors when no results are found from the data source":
    "List of behaviors when no results are found from the data source",
  "This defines the experience when results are not found from the data source.":
    "This defines the experience when results are not found from the data source.",
  "Source material": "Source material",
  "Add data sources to teach your chatbot anything it doesn’t already know.":
    "Add data sources to teach your chatbot anything it doesn’t already know.",
  "Deleting...": "Deleting...",
  "Delete data source": "Delete data source",
  "Are you sure? You’ll no longer be able to use this data source.":
    "Are you sure? You’ll no longer be able to use this data source.",
  "Replace data source": "Replace data source",
  "You’ve reached the maximum number of sources.":
    "You’ve reached the maximum number of sources.",
  "Add source": "Add source",
  "Preview data source chunks": "Preview data source chunks",
  "Show all chunks ({{count}})": "Show all chunks ({{count}})",
  "Max response length (tokens)": "Max response length (tokens)",
  "The default setting is {{contextLimit}} max tokens used per response for this model.":
    "The default setting is {{contextLimit}} max tokens used per response for this model.",
  "Set the max length for individual chatbot responses. The max setting available for this model is {{contextLimit}} tokens.":
    "Set the max length for individual chatbot responses. The max setting available for this model is {{contextLimit}} tokens.",
  "this model": "this model",
  "Only the project owner can manage the Chatbot’s authentication.":
    "Only the project owner can manage the Chatbot’s authentication.",
  "Save changes": "Save changes",
  "Cannot be lower than {{count}}.": "Cannot be lower than {{count}}.",
  "Cannot be higher than {{count}}.": "Cannot be higher than {{count}}.",
  Creativity: "Creativity",
  Predictable: "Predictable",
  Random: "Random",
  "Reset to default": "Reset to default",
  "Connect a custom data source": "Connect a custom data source",
  "Upload a file with your own knowledge to tailor the AI Chatbot responses for your business or project.":
    "Upload a file with your own knowledge to tailor the AI Chatbot responses for your business or project.",
  "Current functionality includes the ability to upload one 1MB static text file (.txt, .csv, .json, .pdf, .doc, .docx).":
    "Current functionality includes the ability to upload one 1MB static text file (.txt, .csv, .json, .pdf, .doc, .docx).",
  Upgrade: "Upgrade",
  "Trigger actions from chatbot responses":
    "Trigger actions from chatbot responses",
  "gets a response": "gets a response",
  "Setup automations that trigger available actions directly in chat.":
    "Setup automations that trigger available actions directly in chat.",
  "Add action": "Add action",
  "Use Case": "Use Case",
  "The user’s full name": "The user’s full name",
  "The user’s primary contact email address. Must resemble a valid email address.":
    "The user’s primary contact email address. Must resemble a valid email address.",
  "The name of the company represented by the user’s inquiry":
    "The name of the company represented by the user’s inquiry",
  "Unable to parse OpenAI response with Zod schema":
    "Unable to parse OpenAI response with Zod schema",
} as const;

export const CHATBOT_BLOCK_COLLECT_USER_DATA_PROPERTIES: Record<
  any,
  {
    type: newFieldType["type"];
    description: string;
  }
> = {
  name: {
    type: "string",
    description: STRINGS["The user’s full name"],
  },
  email: {
    type: "email",
    description:
      STRINGS[
        "The user’s primary contact email address. Must resemble a valid email address."
      ],
  },
  company: {
    type: "string",
    description:
      STRINGS["The name of the company represented by the user’s inquiry"],
  },
};
